module.exports = __webpack_public_path__ + "assets/img/Coolabah-Turf-Article-w720.5afbfc04.jpg";